<div class="cs-hold">
  <div class="cs-hold-inner">
    <h1 class="mat-headline-1 cs-heading">Coming Soon...</h1>
    <a routerLink="/products/active" class="mm-text-center mt-5 mm-d-block mat-headline-6 mm-link mm-text-accent">view my catalogue</a>
  </div>
</div>